export const toAlphaNumDotUppercase = (e: React.FormEvent<HTMLInputElement>) => {
  const target = e.target as HTMLInputElement;
  target.value = target.value
    ? target.value
        .replace(/[^a-zA-Z0-9.]/g, '')
        .replace(/\.(.*)/g, (match, grupo1) => '.' + grupo1.replace(/\./g, ''))
        .toUpperCase()
    : '';
};
